export const AdvancedSearchSortField = Object.freeze({
  /** 累计发生次数 */
  crashCount: 'crashCount',
  /** 累计影响设备数 */
  imeiCount: 'imeiCount',
  /** 匹配次数 */
  matchCount: 'matchCount',
  /** 匹配设备数 */
  deviceMatchCount: 'deviceMatchCount',
});

export const CrashListSortField = Object.freeze({
  /** 发生时间 */
  crashTime: 'crashTime',
  /** 上报时间 */
  uploadTime: 'uploadTime',
});
